<template>
  <b-button
    class="add-button btn-primary"
    :style="resolveColor"
  >
    <div class="d-flex align-items-center">
      <icon-setting-manage class="mr-2" />
      <span>{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import IconSettingManage from '@/@core/components/svg/common/IconSettingManage.vue'
import { computed } from '@vue/composition-api'

export default {
  components: {
    BButton,
    IconSettingManage,
  },
  props: {
    btnLabel: { type: String },
    color: { type: String, default: '#007CFF' },
  },
  setup(props) {
    const resolveColor = computed(() => ({
      'background-color': `${props.color} !important`,
      'border-color': `${props.color} !important`,
    }))
    return {
      resolveColor,
    }
  },
}
</script>
<style></style>

<style scoped>
.add-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  font-size: 20px;
  background-color: #007cff !important;
  border-color: #007cff !important;
  width: 160px;
}

.btn-primary {
  color: #ffffff !important;
}

.btn-primary:hover:not(.disabled):not(:disabled) {
  box-shadow: 0 8px 25px -8px #0060ab;
}

.add-button svg {
  width: 18px;
  height: 18px;
  fill: white;
}
</style>
